export default __webpack_public_path__ + "static/media/rose.5347c194.png";